import React, { Fragment } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import asyncImport from "app/components/helpers/asyncImport";
import { userIsAuthenticated, userIsNotAuthenticated } from "constants/auth-wrapper";
//  main views
const Page404 = asyncImport(() => import("app/components/ui/404"));
const HomePage = asyncImport(() => import("app/views/HomePage"));
const AdminDashboard = asyncImport(() => import("app/admin"));
// admin views
const Carousel = asyncImport(() => import("app/admin/sections/Carousel"));
const Family = asyncImport(() => import("app/admin/sections/Family"));
const About = asyncImport(() => import("app/admin/sections/About/index"));
const Products = asyncImport(() => import("app/admin/sections/Products/index"));
const Contact = asyncImport(() => import("app/admin/sections/Contact"));
const Footer = asyncImport(() => import("app/admin/sections/Footer"));
const Menu = asyncImport(() => import("app/admin/sections/Menu"));
const Production = asyncImport(() => import("app/admin/sections/Production"));
// auth views
const Login = asyncImport(() => import("app/admin/Login"));
const Dashboard = asyncImport(() => import("app/admin/Dashboard"));

//  root routes   /....
export const MainRoutes = [
  { id: 1, path: "/", exact: true, text: "Գլխավոր էջ", component: HomePage },
  { id: 2, path: `/admin`, exact: false, component: AdminDashboard },
  { id: 3, path: "/404", exact: false, text: "Not found", component: Page404 }
];
// admin routes admin/....
export const AuthRoutes = url => [
  { id: 1, path: `${url}/login`, exact: true, text: "Գլխավոր էջ", component: Login },
  { id: 2, path: `${url}/dashboard`, exact: false, component: Dashboard }
];

// dashboard routes , admin/dashboard/.....
export const DashboardRoutes = url => [
  { id: 1, path: `${url}/menu`, exact: true, component: Menu },
  // { id: 2, path: `${url}/carousel`, exact: true, component: Carousel },
  { id: 3, path: `${url}/family`, exact: true, component: Family },
  { id: 4, path: `${url}/about`, exact: true, component: About },
  { id: 5, path: `${url}/production`, exact: true, component: Production },
  { id: 6, path: `${url}/products`, exact: true, component: Products },
  { id: 7, path: `${url}/contact`, exact: true, component: Contact },
  { id: 8, path: `${url}/footer`, exact: true, component: Footer }
];

const MainRouter = () => (
  <Switch>
    {MainRoutes.map(route => (
      <Route key={route.id} exact={route.exact} path={route.path} component={route.component} />
    ))}
    <Redirect to='/404' />
  </Switch>
);

const DashboardRouter = ({ url }) => (
  <Switch>
    {DashboardRoutes(url).map(route => (
      <Route
        key={route.id}
        exact={route.exact}
        path={route.path}
        render={config => <route.component config={config} />}
      />
    ))}
    <Redirect to='/404' />
  </Switch>
);

const AuthRouter = ({ url }) => (
  <Switch>
    {AuthRoutes(url).map(route => (
      <Route
        key={route.id}
        exact={route.exact}
        path={route.path}
        render={config => <route.component config={config} />}
      />
    ))}
    <Redirect to='/404' />
  </Switch>
);

export default {
  MainRouter,
  DashboardRouter,
  AuthRouter
};
